import { requestHttp } from "../utils/HttpRequest";

export const getProfitMarginMetrics = (idUser, idr, date) => {
  try {
    const response = requestHttp({
      endpoint: "profit_margin_metrics",
      data: {
        user_id: idUser,
        idr: idr,
        chosen_date: date,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
